import { makeStyles } from '@material-ui/core/styles'
import { colors } from '../../Themes'

export const useStyles = makeStyles((theme) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: 24,
  },
  pageHeader: {
    backgroundColor: '#F4F4F4',
    padding: '0px 24px',
    marginTop: 5,
  },
  pageContent: {
    padding: '0 24px 30px',
    display: 'flex',
    flexDirection: 'column',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  counterText: {
    fontSize: 14,
    color: colors.primary,
    fontWeight: 500,
    fontFamily: 'Roboto',
    whiteSpace: 'nowrap',
  },
  counterBold: {
    fontWeight: 700,
    color: colors.primary,
  },
  addButton: {
    backgroundColor: colors.primary,
    color: colors.white,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: 8,
    padding: '10px 20px',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: colors.primaryHover,
    },
  },
  infoBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colors.white,
    border: `1px solid ${colors.borderGray}`,
    borderRadius: 8,
    padding: '12px 20px',
    marginTop: 20,
    marginBottom: 4,
    gap: 12,
  },
  infoBannerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  infoIcon: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: `1.5px solid ${colors.primary}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontSize: 12,
    fontWeight: 700,
    color: colors.primary,
    fontFamily: 'Roboto',
    lineHeight: 1,
  },
  goToStore: {
    color: colors.accent,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tableContainer: {
    backgroundColor: colors.white,
    borderRadius: 8,
    border: `1px solid ${colors.borderGray}`,
    marginTop: 16,
    boxShadow: 'none',
    overflow: 'hidden',
  },
  table: {
    minWidth: 600,
  },
  tableHeadCell: {
    backgroundColor: colors.white,
    color: colors.primary,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 700,
    padding: '16px 20px',
    borderBottom: `1px solid ${colors.borderGray}`,
  },
  tableBodyCell: {
    padding: '14px 20px',
    borderBottom: `1px solid ${colors.borderGray}`,
    fontFamily: 'Roboto',
    fontSize: 14,
    color: colors.primary,
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: colors.background,
    },
  },
  statusInvited: {
    display: 'inline-block',
    padding: '4px 14px',
    borderRadius: 20,
    border: '1.5px solid #F5A623',
    color: '#F5A623',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 500,
    backgroundColor: 'transparent',
    lineHeight: '1.4',
  },
  statusActive: {
    display: 'inline-block',
    padding: '4px 14px',
    borderRadius: 20,
    border: '1.5px solid #2196F3',
    color: '#2196F3',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 500,
    backgroundColor: 'transparent',
    lineHeight: '1.4',
  },
  deleteButton: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: '#FDECEA',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FADADD',
    },
  },
  deleteIcon: {
    color: colors.secondary,
    fontSize: 18,
  },
}))
